import { useMemo } from "react";

const COLORS = ["#39ff14", "#9945ff", "#00ffff", "#facc15", "#ff2d2d", "#ff8a00"];

export const Confetti = ({ count = 60 }) => {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        color: COLORS[i % COLORS.length],
        dx: (Math.random() - 0.5) * 520,
        dy: -(180 + Math.random() * 320),
        rot: (Math.random() - 0.5) * 1080,
        delay: Math.random() * 0.15,
        w: 6 + Math.random() * 8,
        h: 8 + Math.random() * 10,
        coin: Math.random() < 0.18,
      })),
    [count],
  );
  return (
    <div className="fp-confetti" data-testid="unlock-confetti" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className={`fp-confetti-piece ${p.coin ? "coin" : ""}`}
          style={{
            "--dx": `${p.dx}px`,
            "--dy": `${p.dy}px`,
            "--rot": `${p.rot}deg`,
            animationDelay: `${p.delay}s`,
            width: p.coin ? 16 : p.w,
            height: p.coin ? 16 : p.h,
            background: p.coin ? "#facc15" : p.color,
          }}
        >
          {p.coin ? "$" : ""}
        </span>
      ))}
    </div>
  );
};
